module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "id": "pageiii"
    }
  }), _c('span', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00002",
      "title": "p. iii"
    }
  }), _vm._v("CONTENTS.")]), _vm._v(" "), _c('table', {
    staticClass: "calibre10",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre11"
  }, [_c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("I. \n"), _c('b', {
    staticClass: "calibre4"
  }, [_vm._v("Neglected Children")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER I."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("STARTLING FACTS.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Pauper Population.—Pauper\nChildren.—Opinions concerning their proper\nTreatment.—A Hundred Thousand Children loose in London\nStreets.—Neglected Babies.—Juvenile “Market\nProwlers”")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("page "), _c('span', {
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004#page1"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER II."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("RESPECTING THE PARENTAGE OF SOME OF OUR\nGUTTER POPULATION.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("Who are the Mothers?—The Infant\nLabour-Market.—Watch London and Blackfriars\nBridges.—The Melancholy Types.—The Flashy, Flaunting\n“Infant.”—Keeping\nCompany.—Marriage.—The Upshot")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#page13"
    }
  }, [_vm._v("13")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER III."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("BABY-FARMING.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("“Baby-Farmers” and Advertising\n“Child-Adopters.”—“F. X.” of\nStepney.—The Author’s Interview with Farmer\nOxleek.—The Case of Baby Frederick Wood")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006#page29"
    }
  }, [_vm._v("29")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER IV."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("WORKING BOYS.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The London Errand-Boy.—His Drudgery and\nPrivations.—His Temptations.—The London Boy after\nDark.—The Amusements provided for him")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#page58"
    }
  }, [_vm._v("58")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_c('a', {
    attrs: {
      "id": "pageiv"
    }
  }), _c('span', {
    attrs: {
      "id": "pgepubid00007",
      "title": "p. iv"
    }
  }), _vm._v("CHAPTER V."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("THE PROBLEM OF DELIVERANCE.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("Curious Problem.—The best Method of\nTreatment.—The “Child of the Gutter” not to be\nentirely abolished.—The genuine Alley-bred Arab.—The\nPoor Lambs of the Ragged Flock.—The Tree of Evil in our\nmidst.—The Breeding Places of Disease and Vice")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#page76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("II. \n"), _c('b', {
    staticClass: "calibre4"
  }, [_vm._v("Professional Thieves")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER VI."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("THEIR NUMBER AND DIFFICULTIES.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("Twenty Thousand Thieves in London.—What it\nmeans.—The Language of\n“Weeds.”—Cleverness of the Pilfering\nFraternity.—A Protest against a barbarous\nSuggestion.—The Prisoner’s great\nDifficulty.—The Moment of Leaving Prison.—Bad\nFriends.—What becomes of Good Resolutions and the\nChaplain’s Counsel?—The Criminal’s Scepticism\nof Human Goodness.—Life in “Little\nHell.”—The Cow-Cross Mission.")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#page85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER VII."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("HOMES AND HAUNTS OF THE BRITISH\nTHIEF.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Three Classes of Thieving Society.—Popular\nMisapprehensions.—A True Picture of the London\nThief.—A Fancy Sketch of the “Under-ground\nCellar.”—In Disguise at a Thieves’\nRaffle.—The Puzzle of “Black Maria.”—Mr.\nMullins’s Speech and his Song")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#page108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER VIII."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("JUVENILE THIEVES.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Beginning of the Downhill Journey.—Candidates\nfor Newgate Honours.—Black Spots of London.—Life from\nthe Young Robber’s Point of View.—The Seedling\nRecruits the most difficult to reform.—A doleful\nSumming-up.—A Phase of the Criminal Question left\nunnoticed.—Budding Burglars.—Streams which keep at\nfull flood the Black Sea of Crime.—"), _c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('span', {
    attrs: {
      "id": "pgepubid00011",
      "title": "p. v"
    }
  }), _vm._v("The Promoters\nof “Gallows Literature.”—Another Shot at a\nFortress of the\nDevil.—“Poison-Literature.”—“Starlight\nSall.”—“Panther Bill”")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#page124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER IX."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("THE THIEF NON-PROFESSIONAL.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Registered and the Unregistered Thieves of the London\nHunting-ground.—The Certainty of the Crop of\nVice.—Omnibus Drivers and Conductors.—The\n“Watchers.”—The London General Omnibus\nCompany.—The Scandal of their System.—The Shopkeeper\nThief.—False Weights and Measures.—Adulteration of\nFood and Drink.—Our Old Law, “I am as honest as I can\nafford to be!”—Rudimentary Exercises in the Art of\nPillage")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#page144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER X."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("CRIMINAL SUPPRESSION AND\nPUNISHMENT.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("Lord Romilly’s Suggestion concerning the Education\nof the Children of Criminals.—Desperate\nCriminals.—The Alleys of the Borough.—The worst\nQuarters not, as a rule, the most noisy.—The Evil Example\nof “Gallows Heroes,” “Dick Turpin,”\n“Blueskin,” &c.—The Talent for\n“Gammoning Lady Green.”—A worthy\nGovernor’s Opinion as to the best way of\n“Breaking” a Bad Boy.—Affection for\n“Mother.”—The Dark Cell and its\nInmate.—An Affecting Interview")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#page173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XI."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("ADULT CRIMINALS AND THE NEW LAW FOR THEIR\nBETTER GOVERNMENT.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("Recent Legislation.—Statistics.—Lord\nKimberley’s “Habitual Criminals”\nBill.—The Present System of License-Holders.—Colonel\nHenderson’s Report.—Social Enemies of Suspected\nMen.—The Wrong-headed Policeman and the Mischief he may\ncause.—Looking out for a Chance.—The last Resource of\ndesperate Honesty.—A Brotherly Appeal.—“Ginger\nwill settle her.”—Ruffians who should be shut up")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#page183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _c('span', {
    attrs: {
      "id": "pgepubid00016",
      "title": "p. vi"
    }
  }), _vm._v("III. \n"), _c('b', {
    staticClass: "calibre4"
  }, [_vm._v("Professional Beggars")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XII."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("THE BEGGAR OF OLDEN TIME.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("“Only a Beggar.”—The Fraternity 333\nYears ago.—A savage Law.—Origin of the\nPoor-Laws.—Irish Distinction in the Ranks of\nBeggary.—King Charles’s\nProclamation.—Cumberland Discipline")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#page211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XIII."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("THE WORK OF PUNISHMENT AND\nRECLAMATION.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Effect of “The Society for the Suppression of\nMendicity.”—State Business earned out by Individual\nEnterprise.—“The Discharged Prisoners’ Aid\nSociety.”—The quiet Work of these\nSocieties.—Their Mode of Work.—Curious\nStatistics.—Singular Oscillations.—Diabolical\nSwindling")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#page221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("221")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XIV."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("BEGGING “DODGES.”")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Variety and Quality of the Imposture.—Superior\nAccomplishments of the Modern Practitioner.—The Recipe for\nSuccess.—The Power of\n“Cheek.”—“Chanting” and the\n“Shallow Lay.”—Estimates of their Paying\nValue.—The Art of touching Women’s Hearts.—The\nHalf-resentful Trick.—The Loudon\n“Cadger.”—The Height of the “Famine\nSeason.”")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#page242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("242")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XV."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("GENTEEL ADVERTISING BEGGARS.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Newspaper Plan and the delicate Process.—Forms\nof Petition.—Novel Applications of\nPhotography.—Personal Attractions of the\nDistressed.—Help, or I perish!")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#page259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("259")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('span', {
    attrs: {
      "id": "pgepubid00021",
      "title": "p. vii"
    }
  }), _vm._v("IV. \n"), _c('b', {
    staticClass: "calibre4"
  }, [_vm._v("Fallen Women")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XVI."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("THIS CURSE.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Difficulty in handling it.—The Question of its\nRecognition.—The Argyll Rooms.—Mr. Acton’s\nVisit there.—The Women and their Patrons.—The\nFloating Population of Windmill-street.—Cremorne Gardens in\nthe Season")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#page271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("271")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XVII."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("THE PLAIN FACTS AND FIGURES OF\nPROSTITUTION.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("Statistics of Westminster, Brompton, and\nPimlico.—Methods of conducting the nefarious\nBusiness.—Aristocratic Dens.—The High\nTariff.—The Horrors of the Social Evil.—The Broken\nBridge behind the Sinner.—“Dress\nLodgers.”—There’s always a\n“Watcher.”—Soldiers and Sailors.—The\n“Wrens of the Curragh”")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#page281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("281")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XVIII."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("THE PRESENT CONDITION OF THE\nQUESTION.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Laws applying to Street-walkers.—The Keepers of\nthe Haymarket Night-houses.—Present Position of the\nPolice-magistrates.—Music-hall\nFrequenters.—Refreshment-bars.—Midnight\nProfligacy—“Snuggeries.”—Over-zealous\nBlockheads.")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021#page304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("304")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XIX."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("SUGGESTIONS.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("Ignoring the Evil.—Punishment fit for the\n“Deserter” and the Seducer.—The\n“Know-nothing” and “Do-nothing”\nPrinciple.—The Emigration of Women of Bad Character")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022#page324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("324")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("V.  "), _c('b', {
    staticClass: "calibre4"
  }, [_vm._v("The\nCurse of Drunkenness")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XX."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("ITS POWER.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The crowning Curse.—No form of sin or sorrow in\nwhich it does not play a part.—The “Slippery\nStone” of Life.—Statistics.—Matters not growing\nworse.—The Army Returns.—The System of\nAdulteration")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023#page332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("332")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('span', {
    attrs: {
      "id": "pgepubid00027",
      "title": "p. viii"
    }
  }), _vm._v("CHAPTER\nXXI."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("ATTEMPTS TO ARREST IT.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Permissive Liquors Bill.—Its Advocates and their\nArguments.—The Drunkenness of the Nation.—Temperance\nFacts and Anecdotes.—Why the Advocates of Total Abstinence\ndo not make more headway.—Moderate Drinking.—Hard\nDrinking.—The Mistake about childish Petitioners")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024#page351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("351")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("VI. \n"), _c('b', {
    staticClass: "calibre4"
  }, [_vm._v("Betting Gamblers")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XXII."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("“ADVERTISING TIPSTERS” AND\n“BETTING COMMISSIONERS.”")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("The Vice of Gambling on the increase among the\nWorking-classes.—Sporting “Specs.”—A\n“Modus.”—Turf\nDiscoveries.—Welshers.—The Vermin of the\nBetting-field.—Their Tactics.—The Road to Ruin")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0025#page377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("377")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("VII.  "), _c('b', {
    staticClass: "calibre4"
  }, [_vm._v("Waste\nof Charity")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XXIII."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("METROPOLITAN PAUPERISM.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("Parochial Statistics.—The Public hold the\nPurse-strings.—Cannot the Agencies actually at work be made\nto yield greater Results?—The need of fair\nRating.—The Heart and Core of the Poor-law\nDifficulty.—My foremost thought when I was a\n“Casual.”—Who are most liable to\nslip?—“Crank-work.”—The Utility of\nLabour-yards.—Scales of Relief.—What comes of\nbreaking-up a Home")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0026#page421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("421")])])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "calibre14"
  }, [_vm._v("CHAPTER XXIV."), _c('br', {
    staticClass: "calibre9"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall1"
  }, [_vm._v("THE BEST REMEDY.")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre12"
  }, [_c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre15"
  }, [_vm._v("Emigration.—The various Fields.—Distinguish\nthe Industrious Worker in need of temporary Relief.—Last\nWords")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('p', {
    staticClass: "calibre16"
  }, [_vm._v("p. "), _c('span', {
    attrs: {
      "id": "pgepubid00031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0027#page455",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("455")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0